import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material";

const Widget = props => {
  const {
    widgetSize = "medium",
    widgetLayout = "column",
    allowShrink = true,
    minHeight = "0px",
  } = props;
  const theme = useTheme();

  const smallerScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Grow in={true}>
      <Paper
        sx={[
          {
            backgroundColor: theme.palette.commonground.main,
            color: theme.palette.commonground.contrastText,
            borderRadius: theme.shape.borderRadius,
            boxShadow: theme.shadows[3],
            position: "relative",
            display: "flex",
            overflowY: "hidden",
            overflowX: "hidden",
            width: "100%",
            flexDirection: widgetLayout,
            height: theme.sizing[widgetSize],
            minHeight: minHeight,
          },
          smallerScreen && {
            height: allowShrink ? "auto" : theme.sizing[widgetSize],
            margin: theme.spacing(0.5),
            width: "calc(100% - 8px)",
            minHeight: minHeight,
          },
        ]}
      >
        {props.children}
      </Paper>
    </Grow>
  );
};

export default Widget;
